import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { apiErrorMsg } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== pwd2) {
      toast.error("Passwords don't match");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: pwd });
      toast.success("Password reset. Please sign in.");
      nav("/login");
    } catch (err) {
      toast.error(apiErrorMsg(err, "Reset failed"));
    }
    setBusy(false);
  };

  if (!token) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center px-6 bg-[#FAFAFA]">
        <div className="bg-white border border-[#E4E4E7] p-8 rounded-sm max-w-sm text-center" data-testid="reset-no-token">
          <h1 className="font-heading font-bold text-xl tracking-tight">Invalid reset link</h1>
          <p className="text-[13px] text-[#52525B] mt-2">No token provided. Request a new reset email.</p>
          <Link to="/forgot-password"><Button className="btn-brand rounded-sm mt-4">Request new link</Button></Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center justify-center bg-[#FAFAFA] px-6">
      <form onSubmit={submit} className="w-full max-w-sm bg-white border border-[#E4E4E7] p-8 rounded-sm" data-testid="reset-form">
        <KeyRound size={22} className="text-[#0055FF] mb-3" />
        <h1 className="font-heading font-bold text-2xl tracking-tight">Set new password</h1>
        <p className="text-[13px] text-[#52525B] mt-1 mb-5">Choose a strong password (min 6 characters).</p>
        <div className="space-y-3">
          <Input type="password" required minLength={6} value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder="New password" className="rounded-sm" data-testid="reset-password" />
          <Input type="password" required minLength={6} value={pwd2} onChange={(e) => setPwd2(e.target.value)} placeholder="Confirm password" className="rounded-sm" data-testid="reset-password-confirm" />
        </div>
        <Button type="submit" disabled={busy} className="btn-brand rounded-sm w-full mt-4" data-testid="reset-submit">
          {busy ? "Updating…" : "Update password"}
        </Button>
      </form>
    </div>
  );
}
